import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// import { getPersonInfo, getPersonSchema } from "./handlers"
import TextInput from "../../components/ReactHookForm/TextInput";
import SelectInput from "../../components/ReactHookForm/SelectInput";
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner";
import { Box } from "@mui/material";
import { Button, Form } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import { getPersonInfo, getPersonSchema } from "./handlers";

const FormBuscarPersona = (props) => {
  const { isLoading, setIsLoading, setDni, setPersonValues, dniActa } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(getPersonSchema),
    defaultValues: {
      dni: dniActa ?? "",
    },
  });

  return (
    <Form onSubmit={handleSubmit((data) => getPersonInfo(data, setIsLoading, setDni, setPersonValues))}>
      <fieldset disabled={isLoading}>
        <Box className='d-flex gap-4'>
          <TextInput name='dni' label='DNI *' register={register} errors={errors?.dni} disabled={dniActa} />
          <SelectInput
            name={`gender`}
            errors={errors.gender}
            label='Género *'
            register={register}
            data={[
              { id: "M", name: "M (masculino)" },
              { id: "F", name: "F (femenino)" },
              { id: "X", name: "X" },
            ]}
          />
          <Button type='submit' className='' disabled={isLoading} style={{ height: "38px", marginTop: "32px", alignSelf: "flex-middle" }}>
            {isLoading ? (
              <Box className='w-full h-full'>
                <ContainedMuniSpinner height={25} width={25} size={35} />{" "}
              </Box>
            ) : (
              <SearchIcon />
            )}
          </Button>
        </Box>
      </fieldset>
    </Form>
  );
};

export default FormBuscarPersona;
